import React from 'react';
import { CardTW } from '../../../../tailwindComponents/CardTW/CardTW';
import type { FCWithChildren } from '../../../../types/FCWithChildren';

// A standard card for AppointmentList, the Wizard, and the AppointmentContainer
export const SchedulingCard: FCWithChildren<{ title?: React.ReactNode }> = ({ children, title }) => {
  return (
    <CardTW title={title} titleClassName={'w-full'} className="sticky top-32">
      {children}
    </CardTW>
  );
};
